import { Link } from "react-router-dom";
import SimpleDrawer from "./sidedrawer";
import { useEffect } from "react";
import { clearNotification } from "../../store/reducers/notifications";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../utils/tool";
import { signOut } from "../../store/actions/users";
import './header.css';
import Logo from '../../assets/99tripdeal-logo-01.svg';
import  Breadcrumb  from "../../custom-hooks/useBreadCrumb.js";
const Header = () => {
    const users = useSelector((state) => state.users);
    const notification = useSelector((state) => state.notification.global);
    const dispatch = useDispatch();
    useEffect(() => {
        if(notification && notification.error){
            showToast("ERROR", notification.message);
            dispatch(clearNotification());
        }
        if(notification && notification.success){
            showToast("SUCCESS", notification.message);
            dispatch(clearNotification());
        }
    }, [notification])

    function signOutUser(){
        dispatch(signOut());
    }

    return (
        <>
        
        <nav className="navbar navbar-expand-lg p-1 d-flex justify-content-between  fixed-top" style={{height: '65px'}}>
           
           <div className="container">
            <Link to="/" className="navbar-brand"><img src={Logo} alt="logo" height={'40px'} width={'100%'}/></Link>
            <SimpleDrawer users={users} Signout={signOutUser} className="hamburger"/>
            </div>

        </nav>
        </>
    )
}


export default Header;